"use client";
import { CheckCircle, X, AlertCircle, Info } from "lucide-react";
import "./Modal.css";

const Modal = ({
  show,
  onClose,
  onConfirm,
  type = "info",
  title,
  message,
  children,
  showButton = true,
}) => {
  if (!show) return null;

  const getIcon = () => {
    switch (type) {
      case "success":
        return <CheckCircle size={24} className="text-success" />;
      case "warning":
        return <AlertCircle size={24} className="text-warning" />;
      case "error":
        return <AlertCircle size={24} className="text-danger" />;
      default:
        return <Info size={24} className="text-info" />;
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Centered icon only for info type */}
        {type === "info" && (
          <div className="modal-icon-centered">
            <Info size={24} className="text-info" />
          </div>
        )}

        <div className="modal-header">
          {/* Left icon for non-info types */}
          {type !== "info" && (
            <div className="modal-icon-centered">{getIcon()}</div>
          )}

          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="modal-body">
          <h3 className="modal-title">{title}</h3>
          <p className="modal-message">{message}</p>
          {children}
        </div>

        {showButton && (
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={() => onConfirm?.()}>
              Delete
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
